const ROUTE = {
  LOGIN: "/",
  ADD_TO_ICI: "/add-to-ici",
  SINGLE_EMAIL_UPLOAD: "/single-email-upload",
  ATTACH_FROM_ICI: "/attach-from-ici",
  LOG_OUT_ICI: "/log-out",
  PREVIEW: "/preview",
};

export { ROUTE };
